import React,{useState,useEffect} from "react";
import {Button,Card,Form,Container,Row,Col} 
 from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useParams } from 'react-router-dom';
import { useFichaConsultante } from '../hooks/useFichaConsultante';
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import {FichaControl} from '../components/Elements/FichaControl'
import { useUsuarioSistema } from '../hooks/useUsuarioSistema';

function FichaUsuarioConsultante (Usuario){
  let usuario=Usuario.usuarioActual.Usuario;
  const usuarioActualSistema = useUsuarioSistema({Usuario:usuario,Genero:'F',CargoId:1});
  const parametros = useParams();
  const {usuarioConsultante,campos,secciones,updateUsuarioConsultante, respuestaServicio,actualizarFicha,setActualizarFicha,
    actualizarFichaElementoCompleto,setActualizarFichaElementoCompleto,updateRespuestaActualizarFicha } = 
    useFichaConsultante({Id:parametros.id});

    const [numberTab,setTab]=useState(1);
    const [ocultarBtn,setOcultarBtn]=useState(false);
    const [isChangedElements,setChange]=useState(false);

    const handleChange = event => {
      let valor=event.target.value;
      if(event.target.className=='form-check-input'){
        valor=event.target.checked;
      }
      const nombre=event.target.name;
      const numeroElemento=event.target.dataset.nroelemento;
      const esMultiple=numeroElemento!=undefined;
        if(!esMultiple){
          setActualizarFicha({...actualizarFicha,[nombre]:
            { 
              valor:valor
            }
          })
        }
        else{
          let newArray;
          if(actualizarFicha[nombre]!=undefined){
            //actualizarFicha[nombre].includes(p=>p.nroElemento)
            const repetido=actualizarFicha[nombre].filter(p=>p.nroElemento==numeroElemento);
            if(repetido.length>0){
            newArray=actualizarFicha[nombre].map(obj => {
              if (obj.nroElemento == numeroElemento) {
               obj.valor=valor;
              }
              return obj;
             })
            }
            else{
              //agregamos
              newArray = [...actualizarFicha[nombre], 
              {
                valor:valor,
                nroElemento:numeroElemento
              }]
            }
          }
          else{
              newArray=[
                {
                  valor:valor,
                  nroElemento:numeroElemento
                }]
          }
          setActualizarFicha({...actualizarFicha,[nombre]:newArray});
        }
    };
    const handleChangeSel = (event,prop) => {
      //event es un arreglo
      if(Array.isArray(event)){
        const nombre=prop.name;
        if(event.length==0){
          const indiceNroElemento=prop.removedValue.index;
          const newArray=[
            {
              valor:[],
              nroElemento:indiceNroElemento
            }]
            setActualizarFicha({...actualizarFicha,[nombre]:newArray});
         
            return;
        }
        let valorArreglo=[];
        for(var i=0;i<event.length;i++){
          valorArreglo.push(event[i].value)
        }
        const valor=valorArreglo;
        const numeroElemento=event[0].index;
        const esMultiple=numeroElemento!=undefined;
        if(!esMultiple){
          setActualizarFicha({...actualizarFicha,[nombre]:
            { 
              valor:valor
            }
            });
        }
        else{
          
          let newArray;
          if(actualizarFicha[nombre]!=undefined &&  actualizarFicha[nombre].length>0){
            const repetido=actualizarFicha[nombre].filter(p=>p.nroElemento==numeroElemento);
            if(repetido.length>0){
              newArray=actualizarFicha[nombre].map(obj => {
                if (obj.nroElemento == numeroElemento) {
                 obj.valor=valor;
                }
                return obj;
               })

            }
            else{
              newArray = [...actualizarFicha[nombre], 
              {
                valor:valor,
                nroElemento:numeroElemento
              }]


            }
          }
          else{
              
                newArray=[
                {
                  valor:valor,
                  nroElemento:numeroElemento
                }]
               
         }
        setActualizarFicha({...actualizarFicha,[nombre]:newArray});
        }
      }
      else{
        const valor=event.value;
        const nombre=prop.name;
        const numeroElemento=event.index;
        const esMultiple=numeroElemento!=undefined;
        if(!esMultiple){
          setActualizarFicha({...actualizarFicha,[nombre]:{ valor:valor}});
        }
        else{
          let newArray;
          if(actualizarFicha[nombre]!=undefined && actualizarFicha[nombre].length>0 ){
            const repetido=actualizarFicha[nombre].filter(p=>p.nroElemento==numeroElemento);
            if(repetido.length>0){
              newArray=actualizarFicha[nombre].map(obj => {
                if (obj.nroElemento == numeroElemento) {
                 obj.valor=valor;
                }
                return obj;
               })

            }
            else{
              newArray = [...actualizarFicha[nombre], 
              {
                valor:valor,
                nroElemento:numeroElemento
              }]
            }
          }
          else{
              newArray=[
                {
                  valor:valor,
                  nroElemento:numeroElemento
                }]
         }
          setActualizarFicha({...actualizarFicha,[nombre]:newArray});
        }
      }
     };
    const handleUpdateElement=(Codigo,Valor) =>{
      setActualizarFichaElementoCompleto({...actualizarFichaElementoCompleto,[Codigo]
        : Valor
      })
        
     }
     const actualizarFichaConsultante=event=>{
      setChange(false);
      updateUsuarioConsultante();
      setChange(true);
     }
     /*useEffect( async() => {
      await updateRespuestaActualizarFicha();  
      
    }, [isChangedElements]);*/
    useEffect( () => {
      async function fichaUsuarioConsultanteFuncion(){
        await updateRespuestaActualizarFicha();  
      }
      fichaUsuarioConsultanteFuncion();
      
    }, [isChangedElements]);

    useEffect( () => {
      if(secciones==null)return;
      async function ocultarBotonGuardar(){
        var seccion=secciones.find(p=>p.Id==numberTab);
        console.log(JSON.stringify(secciones))
        if(seccion?.EsEspecifica)
        {
          setOcultarBtn(true);
        }
        else
        {
          setOcultarBtn(false);
        }
         
      }
      ocultarBotonGuardar();
      
    }, [numberTab]);

  return (
    <>
      <Container fluid>
      <Row>
          <Col sm="12">
            <Card className="card-user">
            <Row style={{marginLeft:"0",marginRight:"0"}}>
              <img
                  alt="..." 
                  height={150}
                  src={
                    require("assets/img/foto.jpeg")
                      .default
                  }
                  style={{display:"block",marginLeft:"0",marginRight:"auto",width:"50%"}}
                  
                ></img>
                <img
                  alt="..." 
                  height={150}
                  src={
                    require("assets/img/foto.jpeg")
                      .default
                  }
                  style={{marginRight:"0",width:"50%"}}
                  
                ></img>
             </Row>
              <Card.Header>
                <Card.Title as="h4">Ficha Usuario Consultante: {usuarioConsultante?.NombreSocial} </Card.Title>
              </Card.Header>
              <br></br><br></br>
              <hr></hr>
              <Card.Body>
              <Tabs
              activeKey={numberTab}
              onSelect={k => setTab(k)}
              //defaultActiveKey="1"
              id="uncontrolled-tab-example"
              className="mb-3">     
                {
                    secciones?.map((item)=>(
                      <Tab eventKey={item?.Id} title={item?.Nombre}>
                        <Form>
                          <Row>
                          {
                          campos?.filter(p => p.SeccionId==item?.Id)?.map((elem,i)=>{
                            const nombre=elem.Codigo;
                            if(usuarioConsultante?.Ficha==undefined){
                              return (<></>);
                            }                            
                            const valor=usuarioConsultante?.Ficha[nombre];
                             
                            return (
                                  <FichaControl
                                    Codigo={elem.Codigo}
                                    Tipo={elem.Tipo}
                                    Opciones={elem.Opciones}
                                    
                                    Schemas={elem.Schemas}
                                    Nombre={elem.Nombre}
                                    EsAdicionable={elem.EsAdicionable}
                                    Valor={valor}
                                    Evento={handleChange}
                                    EventoSel={handleChangeSel}
                                    ActualizarCompleto={handleUpdateElement}                  
                                    >
                                  </FichaControl>
                            )
                            })
                        }
                      </Row>
                      </Form>
                      </Tab>

                    ))
               
              }
              </Tabs>
              <div className="clearfix"></div>
              <br></br>
              <MensajeAlerta mensajeTexto={respuestaServicio.mensajeTexto} estado={respuestaServicio.estado} />

                
                
                  {
                   usuarioConsultante!=undefined && 
                   ocultarBtn==false
                   //(numberTab!=6 && numberTab!=15)
                   ?
                 
                    <>
                    <Row style={{textAlign:'right'}} >
                  
                    <Col xs="5"></Col>
                    <Col xs="6" >
                      <Button
                          id="bntSub"
                          className="btn-fill btn-lg"
                          visible="true"              
                          type="submit"
                          variant="info"
                          onClick={(e)=>{
                            e.preventDefault();
                            actualizarFichaConsultante()
                            }}>
                          Guardar
                      </Button>
                    
                    </Col>

                    <Col xs="1"></Col>

                    </Row>
                    </>
                  
                   :
                   <></>
                  }
                
                
                
              
                  
                  
              </Card.Body>
              
            </Card>
          </Col>
      </Row>
       
      </Container>
    </>
  );
  
}

export default FichaUsuarioConsultante;
